import { Col, Row } from 'antd';
import React from 'react';
import { useState } from 'react';

import "./FilterContainer.css"

function FilterContainer(props) {

    const [isFiltersOpen, setIsFiltersOpen] = useState(false);

    return (
        <>
            <div className='flex-box'>
                <div className='square bottom'>
                    <div className='working_container'>
                      {
                        isFiltersOpen ? (
                           <>
                            <p className='heading'>{props.heading}</p>
                            {props.children}
                           </>
                        ) : <Row justify="center" ><Col span={4} style={{textAlign:'center'}}><button type='link' onClick={() => setIsFiltersOpen(true)} className="search-text" >Click here to search</button></Col></Row>
                      }
                    </div>
                </div>
            </div>
        </>
    )
}

export default FilterContainer;